import { values } from 'lodash-es'
import CONSTANTS from './constants'

export const initialState = {
  [CONSTANTS.SOURCE_DATA]: {
    ...values(CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES).reduce(
      (acc, value) => ({ ...acc, [value]: undefined }),
      {},
    ),
  },
  [CONSTANTS.FORM_DATA]: {
    ticketType: undefined,
    addressId: undefined,
    customerNo: undefined,
    company: undefined,
    address: undefined,
    contactPersonSurname: undefined,
    contactPersonName: undefined,
    phone: undefined,
    email: undefined,
    privacy: false,
    mileage: undefined,
    modelType: undefined,
    damage: undefined,
    description: undefined,
    fileUpload: undefined,
    hubspotId: undefined,
    zip: undefined,
    city: undefined,
    timeValue: undefined,
    distanceValue: undefined,
    saleDate: undefined,
    pickupDate: undefined,
    accidentDate: undefined,
    accidentReport: undefined,
    calculationDesire: undefined,
    operatingHours: undefined,
    serialNo1: undefined,
    serialNo2: undefined,
    lang: undefined,
    reference: undefined,
    openingHours: undefined,
    crdate: undefined,
    again: undefined,
    motorArticleNo: undefined,
    engineSerialNo: undefined,
    errorFrequency: undefined,
    againSoftware: undefined,
    information: undefined,
    veloId: undefined,
    orderId: undefined,
    batteryArticleNo: undefined,
    batterySerialNo: undefined,
    loaderArticleNo: undefined,
    loaderYearOfConstruction: undefined,
    description2: undefined,
    claim: [
      /** default claim data:
        {
          place: 'ort',
          part: 'teil',
          kind: 'art',
          fileUpload: 'datapfad',
          description: '',
        }
      */
    ],
    deliveryNoteNo: undefined,
    acceptTerms: false,
    brand: undefined,
    ctdiDescriptions: {
      [CONSTANTS.CTDI_DESCRIPTIONS_KEYS.CALCULATION_DESIRE]: undefined,
      [CONSTANTS.CTDI_DESCRIPTIONS_KEYS.ERROR_FREQUENCY]: undefined,
      [CONSTANTS.CTDI_DESCRIPTIONS_KEYS.DAMAGE]: undefined,
    },
  },
  [CONSTANTS.COMPLAINT_FORM_COMPONENT.BIKE_SELECTIONS]: [],
  [CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS]: [],
  [CONSTANTS.FORM_ERRORS]: [],
  [CONSTANTS.FORM_PENDING]: false,
  [CONSTANTS.FORM_SUCCESSFUL_SUBMITTED]: false,
  [CONSTANTS.SKIP_STEPS]: [],

  [CONSTANTS.BIKE_COMPONENT_DATA]: {},
}

export default initialState
